export default __webpack_public_path__ + "static/media/safety-certificate.22be18b2.svg";